import {
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from "@mui/material";
import { PropsWithChildren } from "react";

interface ButtonProps extends MuiButtonProps, PropsWithChildren {
  loading?: boolean;
}

export const Button = ({
  loading,
  children,
  disabled,
  ...rest
}: ButtonProps) => {
  return (
    <MuiButton
      {...rest}
      startIcon={loading && <CircularProgress size="1rem" />}
      disabled={disabled || loading}
    >
      {children}
    </MuiButton>
  );
};
